<div class="input-toggle-text">
  @if (!inputToggleTextConfiguration.hideToggle) {
    <app-switch-button
      [switchButtonConfiguration]="inputToggleTextConfiguration.toggleButtonConfiguration"
      [switchButtonModel]="switchButtonModel"
      (switch)="toggleField($event,inputToggleTextConfiguration.code, inputToggleTextModel.value)"
      data-cy="input-toggle-text-switch">
    </app-switch-button>
  }

  @if (inputToggleTextModel.viewMode) {
    <p class="input-toggle-text-view-mode" data-cy="input-toggle-text-view-mode">{{inputToggleTextModel.value | undefinedValue}}</p>
  } @else {
    <div class="input-toggle-input-text">
      @if (!inputToggleTextConfiguration.addCurrency) {
        <app-input-text
          #inputText
          [attr.data-cy]="inputToggleTextDataCy(inputToggleTextConfiguration.code)"
          [initialValue]="inputToggleTextModel.value"
          (inputStateChange)="manageInputTextChange($event)"
          (inputValueChange)="setInputTextValue($event,inputToggleTextConfiguration.code)"
          [messages]="textInputMessages"
          [validators]="inputToggleTextConfiguration.validator"
          [alternateBackground]="true"
          [maxLength]="inputToggleTextConfiguration.maxLength"
          [placeholder]="inputToggleTextConfiguration.placeholder">
        </app-input-text>
      } @else {
        <div class="input-toggle-input-text">
          <app-input-units
            #inputText
            [attr.data-cy]="inputToggleTextDataCy(inputToggleTextConfiguration.code)"
            [initialValue]="inputToggleTextModel.value"
            (inputStateChange)="manageInputTextChange($event)"
            (inputValueChange)="setInputTextValue($event, inputToggleTextConfiguration.code)"
            [messages]="textInputMessages"
            [validators]="inputToggleTextConfiguration.validator"
            [alternateBackground]="true"
            [maxLength]="inputToggleTextConfiguration.maxLength"
            [units]="currencyType"
            [placeholder]="inputToggleTextConfiguration.placeholder">
          </app-input-units>
        </div>
      }
    </div>
  }


</div>
